document.querySelectorAll(".btn-view-360").forEach(function(btn) {
  btn.addEventListener("click", function(e) {
    e.preventDefault();
    document.querySelector(".view-popup").classList.add("open");
  });
});
document.querySelectorAll(".view-overlay").forEach(function(btn) {
  btn.addEventListener("click", function(e) {
    e.preventDefault();
    document.querySelector(".view-popup").classList.remove("open");
  });
});
document.querySelectorAll(".close-360-popup").forEach(function(btn) {
  btn.addEventListener("click", function(e) {
    e.preventDefault();
    document.querySelector(".view-popup").classList.remove("open");
  });
});

function animateScroll(target, duration) {
  var targetElement = document.querySelector(target);
  var targetOffset = targetElement.offsetTop - 110;
  var startOffset = window.pageYOffset;
  var startTime = null;

  function scrollStep(timestamp) {
    if (!startTime) startTime = timestamp;
    var progress = timestamp - startTime;
    var scrollDistance = targetOffset - startOffset;
    var currentScroll = easeInOutCubic(progress, startOffset, scrollDistance, duration);

    window.scrollTo(0, currentScroll);

    if (progress < duration) {
      requestAnimationFrame(scrollStep);
    }
  }

  function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
  }

  requestAnimationFrame(scrollStep);
}

document.querySelectorAll(".menu-sidebar a").forEach(function(element) {
  element.addEventListener('click', function(e) {
    // e.preventDefault();
    var target = this.getAttribute('href');
    // animateScroll(target, 1000);
  });
});

(function ($) {
  $(document).ready(function () {

    var needShow = window.location.hash.substring(1);
    // if(!needShow){
    //   needShow = 'intro';
    // }

    if(needShow){
      $('.shopify-section [data-target]').each(function () {
        if($(this).attr("data-target") != needShow){
          $(this).closest('.shopify-section').removeClass("active").hide();
        }else{
          $(this).closest('.shopify-section').addClass("active").show();
        }
      })
    }

    $(".menu-sidebar a").on("click", function (e) {
      e.preventDefault();
      window.location.href = $(this).attr('href');
      var target = $(this).attr('href').replace('#', '');
      if(target){
        $('.shopify-section [data-target]').closest(".shopify-section").removeClass("active").hide();
        $('.shopify-section [data-target="' + target + '"]').closest(".shopify-section").addClass("active").show();
      }
    })
  })
})(jQuery)

        document.querySelectorAll('.go-top a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();

                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: 'smooth' // スムーズスクロールの挙動を有効にする
                    });
                }
            });
        });

$(function(){ 

  $(window).scroll(function () {
      var scroll = $(window).scrollTop();
			if (scroll > 150){
				$("body").addClass("on");
            } else {
				$("body").removeClass("on");
			}
  });
});